import { forwardRef } from 'react';
import { ButtonV2 } from 'components/shared';
import type { ButtonV2Props } from 'components/shared/ButtonV2';
import styles from './PLCTA.module.css';

export const PL_COLOR_PRIMARY = '#1539f5';
export const PL_COLOR_PRIMARY_HOVER = '#0f2ed4';

export type PLCTAVariant = 'primary' | 'glass' | 'white';

export type PLCTAProps = ButtonV2Props & {
  $plVariant?: PLCTAVariant;
  $hideOnDesktop?: boolean;
};

function plVariantToButtonVariant(
  v: PLCTAVariant | undefined,
): NonNullable<ButtonV2Props['variant']> {
  switch (v ?? 'primary') {
    case 'primary':
      return 'blue';
    case 'glass':
      return 'transparentLight';
    case 'white':
      return 'white';
  }
}

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

const SURFACE_CLASS: Record<PLCTAVariant, string> = {
  primary: styles.plctaPrimary,
  glass: styles.plctaGlass,
  white: styles.plctaWhite,
};

export const PLCTA = forwardRef<HTMLButtonElement, PLCTAProps>(function PLCTA(
  { $plVariant, $hideOnDesktop, className, ...rest },
  ref,
) {
  const variant = $plVariant ?? 'primary';
  return (
    <ButtonV2
      ref={ref}
      variant={plVariantToButtonVariant($plVariant)}
      className={cx(
        styles.plcta,
        SURFACE_CLASS[variant],
        $hideOnDesktop && styles.plctaHideOnDesktop,
        className,
      )}
      {...rest}
    />
  );
});

PLCTA.displayName = 'PLCTA';
